import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Header from "src/components/UI/Header/Header";
import VerticalNavBar from "src/components/UI/VerticalNavBar/VerticalNavBar";
import { GoalsNavigation } from "src/GoalsNavigation";
import { setIsCollapsed } from "src/redux/slices/FinanceLayoutSlice";
import { RootState } from "src/redux/store";

type Props = {
  children?: React.ReactNode | string;
};

const GoalsConfigurationLayout = ({ children }: Props) => {
  const dispatch = useDispatch()
  
  const { isCollapsed }: any = useSelector(
    (state: RootState) => state.financeLayout
  );

  const toggleCollapse = () => {dispatch(setIsCollapsed(!isCollapsed))};
  const location = useLocation();
  const currentPath = `${location.pathname?.split("/")[2]}`;

  return (
    <div className="flex h-screen w-screen relative" tabIndex={0}>
      {/* Side Navigation Bar */}
      <VerticalNavBar
        toggleCollapse={toggleCollapse}
        isCollapsed={isCollapsed}
        navigation={GoalsNavigation}
        isPathEqualtoNavItem={(navItem: any) => navItem.path === currentPath}
      />

      <div
        className={`h-full flex flex-col transition-all duration-500 ${isCollapsed ? "w-full" : "w-[calc(100%-230px)]"
          } `}
      >
        {/* Header */}
        <div className="h-[50px]">
          <Header toggleCollapse={toggleCollapse} isCollapsed={isCollapsed} />
        </div>

        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>

    </div>
  );
};

export default GoalsConfigurationLayout;
